/**
 * The 118 element names, parsed from one locale string and kept for the language they were read in.
 *
 * Lifted out of `reaction-speech` because that module now reads tokens, and the palette that
 * needs these names is what the tokenizer's display table is built from — a cycle that left
 * `CATEGORIES` undefined at import time in whichever module happened to load first. A leaf with
 * no imports of its own cannot take part in one.
 */

import i18n from '@/lib/i18n';

let elementNames: { lang: string; names: Record<string, string> } | null = null;
/**
 * Exported because the Elements palette needs the same names this speaks.
 *
 * One locale string of `Sym:Name` pairs holds all 118 (see the note above on why it is one key
 * and not 118), so a second copy for the buttons would be a second translation to keep in step.
 */
export function elementName(symbol: string): string | null {
  // Keyed on the LANGUAGE, not merely cached. Parsed once and kept forever, a teacher who switched
  // to Portuguese would go on hearing "uranium" — the cache would outlive the reason it was built.
  if (!elementNames || elementNames.lang !== i18n.language) {
    const names: Record<string, string> = {};
    for (const pair of i18n.t('reactions.elementNames').split(' ')) {
      const [sym, name] = pair.split(':');
      if (sym && name) names[sym] = name;
    }
    elementNames = { lang: i18n.language, names };
  }
  return elementNames.names[symbol] ?? null;
}
